import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { DownloadExcelService } from 'src/app/services/download-excel.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { PagesService } from '../pages.service';

@Component({
  selector: 'app-lcl-performance',
  templateUrl: './lcl-performance.component.html',
  styleUrls: ['./lcl-performance.component.scss']
})
export class LclPerformanceComponent implements OnInit {

  filterForm: FormGroup;

  // Table data
  OrderList: any[] = [];
  excelData: any[] = [];

  pageSize = 5;
  currentPage = 0;
  totalSize = 0;
  startIndex = 1;

  selectedDelayType: string | null = null;
  filterBy = '';
  keyword = '';
  keywordDate: Date | null = null;

  selectedDateFilter = 'MTD';
  dateFilter = 'MTD';

  filterToggle = true;
  CustomDate = false;

  loading = false;
  statsLoading = false;

  fromDate: Date | null = null;
  toDate: Date | null = null;

  WeightMatrixPush: any[] = [];
  ChargedWeightMatrixPush: any[] = [];
  ServiceabilityMatrixPush: any[] = [];

  SdaPecentages = '0%';
  NdaPecentages = '0%';

  AppointmentMatrixPie: any[] = [];
  AppoinmentPercentage = '0%';

  DelayMatrixPush: any[] = [];
  DelayHrsMatrixPush: any[] = [];

  IsDelayhrsMetrix = false;
  Pecentages = '0%';
  SectionFilter: string = 'State';
  StateListpush: any[] = [];
  StateListGraph: any[] = [];
  //stateChartView: [number, number] = [650, 380];
  selectedState: string | null = null;
  TotalStateXpcn = 0;
  BrandListpush: any[] = [];
  BrandListGraph: any[] = [];

  selectedBrand: string | null = null;
  TotalBrandXpcn = 0;

  public colorSchemeIntransit = {
    domain: ['#7CC9F0', '#00A2E8', '#FF7F27']
  };

  public colorSchemesAppSDA = {
    domain: ['#7CC9F0', '#00A2E8', '#FF7F27']
  };

  public colorSchemesApp = {
    domain: ['#7CC9F0', '#00A2E8', '#FF7F27']
  };

  public colorSchemeHrsDelay = {
    domain: ['#c05006ff', '#FF7F27', '#f18f4dda']
  };

  public colorScheme = {
    domain: ['#57838D', '#6486A4', '#8EC5AF', '#378D3B', '#0096A6', '#F47B00', '#606060', '#C0AE2A']

  };

  private graphClicked: { [key: string]: boolean } = {};

  constructor(
    readonly fb: FormBuilder,
    readonly _pageService: PagesService,
    readonly _datePipe: DatePipe,
    public alertService: AlertService,
    public _downloadExcelService: DownloadExcelService
  ) {
    this.filterForm = this.fb.group({
      FilterType: new FormControl('MTD'),
      FromDate: new FormControl(null),
      ToDate: new FormControl(null),
      StartIndex: new FormControl(1),
      EndIndex: new FormControl(5),
      CustomerId: new FormControl(null),
      DestinationGateway: new FormControl(null),
      OriginGatewayId: new FormControl(null),
      StateFilter: new FormControl(null),
      BrandFilter: new FormControl(null),
      GatewayIds: new FormControl(null),
      OriginStateIds: new FormControl(null),
      Xpcn: new FormControl(null),
      BookingId: new FormControl(null),
      DOC: new FormControl(null),
      ServiceType: new FormControl(null),
      FilterDateType: new FormControl('MTD'),
      DelayType: new FormControl(null),
      UserType: new FormControl(null),
      IsAppointmentDelivery: new FormControl(null),
      IsSda: new FormControl(null),
      TatType: new FormControl(null),
      ExcludeCustomerId: new FormControl(null),
      Permissions: new FormControl(null),
      OriginPincode: new FormControl(null),
      DestinationPincode: new FormControl(null),
      originGatewayIds: new FormControl(null),
      IsVasService: new FormControl(null),
      PODStatus: new FormControl(null),
      IsUndelivered: new FormControl(null)
    });
  }

  ngOnInit(): void {
    this.filterForm.patchValue({
      FilterType: 'MTD',
      FilterDateType: 'MTD',
      FromDate: this.formatDateForApi(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      ),
      ToDate: this.formatDateForApi(new Date()),
      StartIndex: 1,
      EndIndex: this.pageSize
    });

    this.getData(true);
  }

  private dataRequestId = 0;

  getData(loadStats = false): void {
    const requestId = ++this.dataRequestId;

    const request = {
      ...this.filterForm.getRawValue(),
      SectionFilter: this.SectionFilter
    };

    this.loading = true;

    this._pageService.GetCustomerPerformance(request)
      .pipe(
        finalize(() => {
          if (requestId === this.dataRequestId) {
            this.loading = false;
          }
        })
      )
      .subscribe({
        next: (res: any) => {
          if (requestId !== this.dataRequestId) {
            return;
          }

          if (res?.Success === true && res.Data != null) {
            const responseData = res.Data;

            if (Array.isArray(responseData.Data)) {
              this.OrderList = responseData.Data;
              this.totalSize = Number(
                responseData.TotalCount ?? this.OrderList.length
              );
            } else if (Array.isArray(responseData)) {
              this.OrderList = responseData;
              this.totalSize =
                this.OrderList.length > 0 &&
                  this.OrderList[0].TotalRecords != null
                  ? Number(this.OrderList[0].TotalRecords)
                  : this.OrderList.length;
            } else {
              this.OrderList = [];
              this.totalSize = 0;
            }
          } else {
            this.OrderList = [];
            this.totalSize = 0;
          }

          // Load stats only after totalSize is updated.
          if (loadStats) {
            this.getPerformanceStats();
          }
        },
        error: () => {
          if (requestId !== this.dataRequestId) {
            return;
          }

          this.OrderList = [];
          this.totalSize = 0;

          this.alertService.createAlert(
            'Unable to load LCL Performance data',
            0
          );
        }
      });
  }

  private statsRequestId = 0;

  getPerformanceStats(): void {
    const requestId = ++this.statsRequestId;
    this.statsLoading = true;

    const formValue = this.filterForm.getRawValue();

    const request = {
      ...formValue,
      SectionFilter: this.SectionFilter,
      FilterType: formValue.FilterType,
      FilterDateType: formValue.FilterDateType,
      FromDate: formValue.FromDate,
      ToDate: formValue.ToDate,
      DelayType: formValue.DelayType ?? null,
      StartIndex: 1,
      EndIndex: Math.max(this.totalSize, this.pageSize)
    };

    this._pageService.GetCustomerPerformanceStats(request)
      .pipe(
        finalize(() => {
          if (requestId === this.statsRequestId) {
            this.statsLoading = false;
          }
        })
      )
      .subscribe({
        next: (res: any) => {
          if (requestId !== this.statsRequestId) {
            return;
          }

          let statsData: any = res;

          for (let i = 0; i < 3 && statsData; i++) {
            if (
              !Array.isArray(statsData) &&
              statsData.Data != null
            ) {
              statsData = statsData.Data;
            } else if (
              !Array.isArray(statsData) &&
              statsData.data != null
            ) {
              statsData = statsData.data;
            } else {
              break;
            }
          }

          this.mapStatsToCharts(statsData);
        },
        error: () => {
          if (requestId === this.statsRequestId) {
            this.clearChartData();
          }
        }
      });
  }

  private mapStatsToCharts(response: any): void {
    if (!response || typeof response !== 'object') {
      this.clearChartData();
      return;
    }

    const delayMatrix = this.getProperty(response, 'DelayMatrix');
    const weightMatrix = this.getProperty(response, 'WeightMatrix');
    const chargedWeightMatrix = this.getProperty(
      response,
      'ChargedWeightMatrix'
    );
    const serviceability = this.getProperty(
      response,
      'Serviceability'
    );
    const appointmentMatrix = this.getProperty(
      response,
      'AppointmentMatrix'
    );
    const states = this.getProperty(response, 'States');
    const brands = this.getProperty(response, 'Brands');

    this.mapWeightMatrix(weightMatrix, chargedWeightMatrix);
    this.mapServiceability(serviceability);
    this.mapAppointmentMatrix(appointmentMatrix);
    this.mapDelayMatrix(delayMatrix);
    this.mapStateList(states);
    this.mapBrandList(brands);
  }

  private mapBrandList(brands: any): void {

    const list: any[] = Array.isArray(brands) ? brands : [];

    this.BrandListGraph = list;

    this.BrandListpush = list
      .filter(item => !!this.getProperty(item, 'Name'))
      .map(item => ({
        name: String(this.getProperty(item, 'Name')),
        value: this.getNumber(item, 'Count'),
        extra: {
          delayMatrix: this.getProperty(item, 'DelayMatrix') || [],
          weightMatrix: this.getProperty(item, 'WeightMatrix') || []
        }
      }));

    this.TotalBrandXpcn = this.BrandListpush.reduce(
      (sum: number, item: any) => sum + item.value,
      0
    );
  }

  private mapStateList(states: any): void {
    const list: any[] = Array.isArray(states) ? states : [];
    this.StateListGraph = list;

    this.StateListpush = list
      .filter(item => !!this.getProperty(item, 'Name'))
      .map(item => ({
        name: String(this.getProperty(item, 'Name')),
        value: this.getNumber(item, 'Count'),
        extra: {
          delayMatrix: this.getProperty(item, 'DelayMatrix') || [],
          weightMatrix: this.getProperty(item, 'WeightMatrix') || []
        }
      }));

    this.TotalStateXpcn = this.StateListpush.reduce(
      (sum: number, item: any) => sum + item.value,
      0
    );
  }

  onSelectBrand(event: any): void {

    const brandName = String(
      event?.name ?? event?.label ?? ''
    ).trim();

    if (!brandName || brandName === '-') {
      return;
    }

    this.selectedBrand =
      this.selectedBrand === brandName ? null : brandName;

    this.applyBrandFilter();
  }

  private applyBrandFilter(): void {

    this.filterForm.patchValue({
      BrandFilter: this.selectedBrand
    });

    this.resetPagination();

    this.getData(true);
  }

  clearSectionFilter(): void {

    if (this.SectionFilter === 'State') {

      this.selectedState = null;

      this.filterForm.patchValue({
        StateFilter: null
      });

    } else if (this.SectionFilter === 'brand') {

      this.selectedBrand = null;

      this.filterForm.patchValue({
        BrandFilter: null
      });
    }

    this.resetPagination();

    this.getData(true);
  }

  private getDictionaryValue(
    source: any,
    dictionaryKey: string
  ): any[] {
    if (!source || typeof source !== 'object') {
      return [];
    }

    // AppointmentMatrix may be an array.
    if (Array.isArray(source)) {
      return source;
    }

    // Serviceability may contain keys such as SDA and NDA.
    const matchingKey = Object.keys(source).find(
      key => key.toLowerCase() === dictionaryKey.toLowerCase()
    );

    const value = matchingKey !== undefined
      ? source[matchingKey]
      : undefined;

    return Array.isArray(value) ? value : [];
  }

  private getNumber(source: any, propertyName: string): number {
    const value = this.getProperty(source, propertyName);

    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const numberValue = Number(value);

    return Number.isFinite(numberValue) ? numberValue : 0;
  }

  private getProperty(source: any, propertyName: string): any {
    if (!source || typeof source !== 'object') {
      return undefined;
    }

    const matchingKey = Object.keys(source).find(
      key => key.toLowerCase() === propertyName.toLowerCase()
    );

    return matchingKey !== undefined
      ? source[matchingKey]
      : undefined;
  }

  private toStackedWeightChart(matrix: any): any[] {
    if (!matrix || typeof matrix !== 'object') {
      return [];
    }

    return Object.keys(matrix)
      .filter(key => Array.isArray(matrix[key]))
      .map(key => ({
        name: key,
        series: matrix[key].map((item: any) => ({
          name: String(
            this.getProperty(item, 'DelayStatus') ?? 'Unknown'
          ),
          value: this.getNumber(item, 'Count')
        }))
      }));
  }

  // 1. Actual and charged weight charts
  private mapWeightMatrix(
    weightMatrix: any,
    chargedWeightMatrix: any
  ): void {
    this.WeightMatrixPush = this.toStackedWeightChart(weightMatrix);

    this.ChargedWeightMatrixPush =
      this.toStackedWeightChart(chargedWeightMatrix);
  }

  // 2. SDA / NDA metrics
  private mapServiceability(serviceability: any): void {
    const statuses = ['OnTime', 'Early Delivery', 'Delay'];

    const getStatusCount = (items: any[], status: string): number => {
      const item = items.find(
        x => String(this.getProperty(x, 'DelayStatus') ?? '')
          .trim()
          .toLowerCase() === status.toLowerCase()
      );
      return item ? this.getNumber(item, 'Count') : 0;
    };

    const buildGroup = (key: string) => {
      const items = this.getDictionaryValue(serviceability, key);
      const counts = statuses.map(s => getStatusCount(items, s));
      const total = counts.reduce((a, b) => a + b, 0);
      const pct = (value: number) => (total > 0 ? (value / total) * 100 : 0);

      const onTimeEarlyPct = pct(counts[0]) + pct(counts[1]);
      const delayPct = pct(counts[2]);

      return {
        chart: {
          name: key,
          series: statuses.map((status, i) => ({
            name: `${status}\n${pct(counts[i]).toFixed(2)}%`,
            value: counts[i]
          }))
        },
        text: `${onTimeEarlyPct.toFixed(2)}%, ${delayPct.toFixed(2)}%`
      };
    };

    const sda = buildGroup('SDA');
    const nda = buildGroup('NDA');

    this.ServiceabilityMatrixPush = [sda.chart, nda.chart];
    this.SdaPecentages = sda.text;   // e.g. "83.57%, 16.44%"
    this.NdaPecentages = nda.text;   // e.g. "81.81%, 18.18%"
  }

  // 3. Appointment delivery metrics
  private mapAppointmentMatrix(appointmentMatrix: any): void {
    let matrix: any[] = [];

    if (Array.isArray(appointmentMatrix)) {
      matrix = appointmentMatrix;
    } else if (appointmentMatrix && typeof appointmentMatrix === 'object') {
      const firstArray = Object.values(appointmentMatrix)
        .find((v): v is any[] => Array.isArray(v));

      matrix = firstArray || [];
    }

    const statuses = ['OnTime', 'Early Delivery', 'Delay'];

    this.AppointmentMatrixPie = statuses.map(status => {
      const item = matrix.find(
        (x: any) =>
          String(this.getProperty(x, 'DelayStatus') ?? '')
            .trim()
            .toLowerCase() === status.toLowerCase()
      );

      return {
        name: status,
        value: item ? this.getNumber(item, 'Count') : 0
      };
    });

    const total = this.AppointmentMatrixPie.reduce(
      (sum: number, item: any) => sum + item.value,
      0
    );

    const onTimeCount =
      this.AppointmentMatrixPie.find(
        (item: any) => item.name === 'OnTime'
      )?.value ?? 0;

    this.AppoinmentPercentage = this.toPercentage(onTimeCount, total);
  }

  // 4. XPCN delay metrics
  private mapDelayMatrix(delayMatrix: any): void {
    const statuses = ['OnTime', 'Early Delivery', 'Delay'];
    const items: any[] = Array.isArray(delayMatrix) ? delayMatrix : [];

    // Keep all 3 statuses (even with 0) so OnTime always shows in the pie
    this.DelayMatrixPush = statuses.map(status => {
      const item = items.find(x =>
        String(
          this.getProperty(x, 'DelayStatus') ??
          this.getProperty(x, 'DelayType') ??
          ''
        ).trim().toLowerCase() === status.toLowerCase()
      );

      return {
        name: status,
        value: item ? this.getNumber(item, 'Count') : 0
      };
    });

    const total = this.DelayMatrixPush.reduce((s, i) => s + i.value, 0);
    const onTime = this.DelayMatrixPush[0].value;
    const early = this.DelayMatrixPush[1].value;
    const delay = this.DelayMatrixPush[2].value;

    const onTimeEarlyPct = total > 0 ? ((onTime + early) / total) * 100 : 0;
    const delayPct = total > 0 ? (delay / total) * 100 : 0;

    // e.g. "82.33%, 17.67%"
    this.Pecentages = `${onTimeEarlyPct.toFixed(2)}%, ${delayPct.toFixed(2)}%`;
    this.DelayHrsMatrixPush = [];
  }

  private toPercentage(value: number, total: number): string {
    if (total <= 0) {
      return '0%';
    }

    return `${((value / total) * 100).toFixed(2)}%`;
  }

  private clearChartData(): void {
    this.WeightMatrixPush = [];
    this.ChargedWeightMatrixPush = [];

    this.ServiceabilityMatrixPush = [];
    this.SdaPecentages = '0%';
    this.NdaPecentages = '0%';

    this.AppointmentMatrixPie = [];
    this.AppoinmentPercentage = '0%';

    this.DelayMatrixPush = [];
    this.DelayHrsMatrixPush = [];
    this.Pecentages = '0%';
    this.StateListpush = [];
    this.StateListGraph = [];
    this.TotalStateXpcn = 0;
    this.BrandListpush = [];
    this.BrandListGraph = [];
    this.TotalBrandXpcn = 0;
  }

  openCustomDateFilter(): void {
    this.CustomDate = true;
    this.selectedDateFilter = 'CustomDate';
  }

  dateFilterChanged(type: string): void {
    if (type === 'Dates') {
      if (!this.fromDate || !this.toDate) {
        this.alertService.createAlert('Please select both From Date and To Date', 0);
        return;
      }

      const from = this.formatDateForApi(this.fromDate);
      const to = this.formatDateForApi(this.toDate);

      if (!from || !to) {
        this.alertService.createAlert('Please select valid dates', 0);
        return;
      }

      if (from > to) {
        this.alertService.createAlert('From date cannot be greater than To date', 0);
        return;
      }

      this.dateFilter = 'Dates';
      this.selectedDateFilter = 'CustomDate';
      this.CustomDate = true;

      this.filterForm.patchValue({
        FilterType: 'Dates',
        FilterDateType: 'Dates',
        FromDate: from,
        ToDate: to
      });
    } else {
      if (!['Today', 'Last7Days', 'MTD', 'YTD'].includes(type)) {
        return;
      }

      this.dateFilter = type;
      this.selectedDateFilter = type;
      this.CustomDate = false;
      this.fromDate = null;
      this.toDate = null;

      this.applyDateRange(type);
    }

    this.resetPagination();
    this.getData(true);
  }

  onSelectState(event: any): void {
    const stateName = String(event?.name ?? event?.label ?? '').trim();

    // "-" is the placeholder for rows with no state, so it can't be filtered on
    if (!stateName || stateName === '-') {
      return;
    }

    // Clicking the selected state again clears the filter
    this.selectedState = this.selectedState === stateName ? null : stateName;
    this.applyStateFilter();
  }

  clearStateFilter(): void {
    if (!this.selectedState) {
      return;
    }
    this.selectedState = null;
    this.applyStateFilter();
  }

  private applyStateFilter(): void {
    this.filterForm.patchValue({ StateFilter: this.selectedState });
    this.resetPagination();
    this.getData(true);   // grid first, then stats once totalSize is known
  }

  private applyDateRange(type: string): void {
    const today = new Date();

    const toDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    let fromDate: Date;

    switch (type) {
      case 'Today':
        fromDate = new Date(toDate);
        break;

      case 'Last7Days':
        fromDate = new Date(toDate);
        fromDate.setDate(fromDate.getDate() - 6);
        break;

      case 'YTD':
        fromDate = new Date(
          toDate.getFullYear(),
          0,
          1
        );
        break;

      case 'MTD':
      default:
        fromDate = new Date(
          toDate.getFullYear(),
          toDate.getMonth(),
          1
        );
        break;
    }

    this.filterForm.patchValue({
      FilterType: type,
      FilterDateType: type,
      FromDate: this.formatDateForApi(fromDate),
      ToDate: this.formatDateForApi(toDate),
      StartIndex: 1,
      EndIndex: this.pageSize
    });
  }

  datefilterclear(): void {
    this.fromDate = null;
    this.toDate = null;

    this.CustomDate = false;
    this.dateFilter = 'MTD';
    this.selectedDateFilter = 'MTD';

    this.applyDateRange('MTD');
    this.resetPagination();

    this.getData(true);
    // this.getPerformanceStats();
  }

  private formatDateForApi(
    value: Date | string | null
  ): string | null {
    if (!value) {
      return null;
    }

    let date: Date;

    if (value instanceof Date) {
      date = value;
    } else {
      const dateOnlyMatch =
        /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

      if (dateOnlyMatch) {
        date = new Date(
          Number(dateOnlyMatch[1]),
          Number(dateOnlyMatch[2]) - 1,
          Number(dateOnlyMatch[3])
        );
      } else {
        date = new Date(value);
      }
    }

    if (Number.isNaN(date.getTime())) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  filter(): void {
    if (!this.filterBy) {
      this.alertService.createAlert(
        'Please select Filter By',
        0
      );
      return;
    }

    const value = (this.keyword || '').trim();

    if (this.filterBy !== 'any' && !value) {
      this.alertService.createAlert(
        'Please enter a keyword',
        0
      );
      return;
    }

    this.filterForm.patchValue({
      BookingId: null,
      Xpcn: null,
      DOC: null,
      ServiceType: null,
      CustomerId: null
    });

    switch (this.filterBy) {
      case 'booking':
        this.filterForm.patchValue({
          BookingId: value
        });
        break;

      case 'xpcn':
        this.filterForm.patchValue({
          Xpcn: value
        });
        break;

      case 'service_type':
        this.filterForm.patchValue({
          ServiceType: value
        });
        break;

      default:
        this.alertService.createAlert(
          'Invalid filter selected',
          0
        );
        return;
    }

    this.resetPagination();
    this.getData(true);
  }

  clear(): void {
    this.filterBy = '';
    this.keyword = '';
    this.keywordDate = null;

    this.filterForm.patchValue({
      BookingId: null,
      Xpcn: null,
      DOC: null,
      ServiceType: null,
      CustomerId: null
    });

    this.resetPagination();
    this.getData(true);
  }

  private resetPagination(): void {
    this.currentPage = 0;
    this.startIndex = 1;

    this.filterForm.patchValue({
      StartIndex: 1,
      EndIndex: this.pageSize
    });
  }

  public handlePage(e: any, isReset = false) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    if (this.currentPage == 0) {
      this.startIndex = 1;
    } else {
      this.startIndex = (this.currentPage * this.pageSize) + 1;
    }
    this.filterForm.controls['StartIndex'].setValue(this.startIndex);
    this.filterForm.controls['EndIndex'].setValue(this.pageSize);
    this.getData();
  }

  subtasks: any[] = [
    {
      name: 'Charged Weight',
      completed: true,
      color: 'primary'
    },
    {
      name: 'Actual Weight',
      completed: false,
      color: 'primary'
    }
  ];

  ShowChargedWeight = true;

  OncheckBox(selectedTask: any): void {
    this.subtasks.forEach(
      task => task.completed = false
    );

    selectedTask.completed = true;

    this.ShowChargedWeight =
      selectedTask.name === 'Charged Weight';
  }


  getGraphClicked(graphName: string): boolean {
    return !!this.graphClicked[graphName];
  }

  ResetGraphMatrix(graphName: string): void {
    this.graphClicked[graphName] = false;

    if (graphName !== 'DelayMatrixGraph') {
      return;
    }

    this.selectedDelayType = null;
    this.filterForm.patchValue({ DelayType: null });

    this.resetPagination();
    this.getData(true); // stats load after totalSize is updated
  }

  onSelectGraph(event: any, graphName: string): void {
    if (graphName !== 'DelayMatrixGraph') {
      return;
    }

    const selectedStatus = String(
      event?.name ??
      event?.label ??
      event?.series ??
      ''
    ).trim();

    if (!selectedStatus) {
      return;
    }

    this.selectedDelayType =
      this.selectedDelayType === selectedStatus
        ? null
        : selectedStatus;

    this.graphClicked[graphName] =
      this.selectedDelayType !== null;

    this.filterForm.patchValue({
      DelayType: this.selectedDelayType
    });

    this.resetPagination();

    this.getData(true);
    //this.getPerformanceStats();
  }

  xAxisTickFormatting(value: any): string {
    return value == null
      ? ''
      : String(value);
  }


  public exportAsExcel() {
    this.excelData = [];
    let list: any[] = [];

    this.filterForm.controls['EndIndex'].setValue(this.totalSize);

    this._pageService.GetCustomerPerformance(this.filterForm.value).subscribe((data: any) => {
      if (data != null) {
        if (data.Data && Array.isArray(data.Data.Data)) {
          list = data.Data.Data;
        } else if (Array.isArray(data.Data)) {
          list = data.Data;
        }

        if (list.length > 0) {
          list.forEach((element: any) => {
            this.excelData.push({
              'Booking Date': this._datePipe.transform(element['BookingDate'], 'dd-MM-y'),
              'Booking Id': element['BookingNo'],
              'XPCN': element['XpcnNo'],
              'Doc/LR/PO/ASN': element['PoLr'],
              'Order Type': element['OrderType'],
              'Origin': element['Origin'],
              'Origin Postcode': element['OriginPostcode'],
              'Origin State': element['OriginState'],
              'Destination': element['Destination'],
              'Destination Postcode': element['Destinationpostcode'],
              'Destination State': element['DestinationState'],
              'Picked Date': this._datePipe.transform(element['PickedDate'], 'dd-MM-y'),
              'Standard EDD': this._datePipe.transform(element['StandardEDD'], 'dd-MM-y'),
              'Delivery Date': this._datePipe.transform(element['DeliveryDate'], 'dd-MM-y'),
              'Appointment Delivery': element['AppointmentDeliveryMode'],
              'Appointment Date': this._datePipe.transform(element['AppointmentDate'], 'dd-MM-y'),
              'Undelivered Reason': element['UndeliveredReason'],
              'Status': element['Status'],
              'Delivery Days': element['DeliveryDays'],
              'Invoice Value': element['InvoiceValue'],
              'Consignor': element['ConsignorName'],
              'Consignee': element['ConsigneeName'],
              'Brand': element['Brand'],
              'Actual Weight': element['ActualWeight'],
              'Charged Weight': element['charged_weight'],
              'Total Boxes': element['TotalBoxes'],
              'Quantity/Pieces': element['QuantityPieces'],
              'Serviceability': element['Serviceability'],
              'POD Status': element['PODStatus'],
              // 'Undelivery': element['UnDelivery'],
              'COD/DOD': element['COD_DOD'],
              'Payment Mode': element['PaymentMode']
            });
          });
        } else {
          this.excelData.push({
            'Booking Date': '-',
            'Booking Id': '-',
            'XPCN': '-',
            'Doc/LR/PO/ASN': '-',
            'Order Type': '-',
            'Origin': '-',
            'Origin Postcode': '-',
            'Origin State': '-',
            'Destination': '-',
            'Destination Postcode': '-',
            'Destination State': '-',
            'Picked Date': '-',
            'Standard EDD': '-',
            'Delivery Date': '-',
            'Appointment Delivery': '-',
            'Appointment Date': '-',
            'Undelivered Reason': '-',
            'Status': '-',
            'Delivery Days': '-',
            'Invoice Value(s)': '-',
            'Consignor': '-',
            'Consignee': '-',
            'Actual Weight': '-',
            'Charged Weight': '-',
            'Total Boxes': '-',
            'Quantity/Pieces': '-',
            'Serviceability': '-',
            'POD Status': '-',
            // 'Undelivery': '-',
            'COD/DOD': '-',
            'Payment Mode': '-'
          });
        }

        this._downloadExcelService.exportAsExcelFile(
          this.excelData,
          'LCL Performance'
        );
      }
    });
  }

  onSectionChange(event: any): void {
    const selectedSection = event?.value;

    // if (!selectedSection || this.SectionFilter === selectedSection) {
    //   return;
    // }
    // Only State section is enabled for now.
    if (selectedSection !== 'State' || this.SectionFilter === 'State') {
      return;
    }

    this.SectionFilter = selectedSection;
    this.resetPagination();
    this.selectedState = null;
    this.selectedBrand = null;
    this.selectedDelayType = null;
    this.graphClicked = {};

    this.filterForm.patchValue({
      DelayType: null,
      StateFilter: null,
      StartIndex: 1,
      EndIndex: this.pageSize
    });

    this.getData(true);
  }

}